const hlsEvents = {
  FRAG_LOADED: 'FRAG_LOADED',
  FRAG_PARSING_METADATA: 'FRAG_PARSING_METADATA',
  ERROR: 'ERROR',
  LEVEL_LOADED: 'LEVEL_LOADED',
  BUFFER_APPENDED: 'BUFFER_APPENDED',
};

export default hlsEvents;
